import axios from 'axios'
import qs from 'qs'

// axios.defaults.baseURL =  'http://toktok.xsbanruo.com';   //配置接口地址-测试
// axios.defaults.baseURL =  'http://test.toktok.beer';   //配置接口地址-测试
axios.defaults.baseURL =  '//toktok.beer';   //配置接口地址-生产
axios.defaults.timeout = 5000;  //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //配置请求头
axios.defaults.headers.common["Auth-User-Agent"] = "H5#H5#H5#201#201";

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    if(config.method  === 'post'){
        config.data = qs.stringify(config.data);
    }
    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    if(!res.data.success){
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    console.log('网络异常')
    return Promise.reject(error);
});

export default {
    //返回一个Promise(发送post请求)
    fetchPost(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, params)
                .then(response => {
                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    //返回一个Promise(发送get请求)
    fetchGet(url, param) {
        return new Promise((resolve, reject) => {
            axios.get(url, {params: param})
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    //获取URL参数
    getUrlKey (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    //微信配置
    getShopWxConfig() {
        let url = encodeURIComponent(location.href.split('#')[0]);
        this.fetchGet('/app/h5/wechat/jsapi/sign',{url:url}).then((res) => {
            //console.log('res:', res.data.data);
            wx.config({
                debug: false,
                appId: res.data.data.appid,
                nonceStr: res.data.data.noncestr,
                timestamp: res.data.data.timestamp,
                signature: res.data.data.signature,
                openTagList: ['wx-open-launch-weapp'],
                jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'checkJsApi',
                'scanQRCode',
                ],
            });
            wx.ready(function () {
                console.log('sucess_wx');
            });
            wx.error(function (err) {
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                console.log('err_wx', err);
            });
        }).catch((err)=>{
            console.log(err)
        });
    },

    wxShare(that){
        //自定义微信分享
        var localUrl = encodeURIComponent(location.href.split('#')[0]);
        this.fetchGet('/h5/wxjsapi/signature',{url:localUrl})
        .then((res) => {
            if(res.data.code == 200){
                //console.log(res);
                //通过微信config接口注入配置
                wx.config({
                    debug: false, // 默认为false  为true的时候是调试模式，会打印出日志
                    appId: res.data.data.appid,
                    timestamp: res.data.data.timestamp,
                    nonceStr: res.data.data.noncestr,
                    signature: res.data.data.signature,
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo'
                    ]
                });
                //配置自定义分享内容
                window.share_config = {
                    'share': {
                        'imgUrl': 'https://www.xsbanruo.com/logo.png', // 这里是需要展示的图标
                        'desc': '在线修行，福报自来。', // 这是分享展示的摘要
                        'title': '佛系如我，已坚持修行'+that.userData.totalDayCount+'天！', // 这是分享展示卡片的标题
                        'link': location.href, // 这里是分享的网址
                        'success': function(rr) {
                            console.log('成功' + JSON.stringify(rr))
                        },
                        'cancel': function(tt) {
                            console.log('失败' + JSON.stringify(tt));
                        }
                    }
                };
                wx.ready(function() {
                    wx.onMenuShareAppMessage(share_config.share); // 微信好友
                    wx.onMenuShareTimeline(share_config.share); // 微信朋友圈
                    wx.onMenuShareQQ(share_config.share); // QQ
                });
            }else{
                console.log(res)
            }
        })
        .catch((err)=>{
            console.log(err)
        });
    }
}



// WEBPACK FOOTER //
// ./src/action/net.js